// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"140":"a8531722","184":"f94e0332","804":"f94e0332","931":"ca4b39be","959":"ca4b39be"}[chunkId] + ".css";
};